import { PUBLIC_CLOUDINARY_CLOUD_NAME } from "$app/env/public";
import { createCloudinaryUrls } from "@fergmar/ui/cloudinary";

const urls = createCloudinaryUrls(PUBLIC_CLOUDINARY_CLOUD_NAME);

export const {
	CLOUDINARY_IMAGE_UPLOAD_BASE,
	cloudinaryUrl,
	cloudinaryVideoUrl,
	cloudinaryVideoPoster,
	cloudinarySrcset,
	cloudinaryFetch
} = urls;

export type { CloudinaryOpts, CloudinaryVideoOpts } from "@fergmar/ui/cloudinary";
